// Builds the dispatch payload for selecting a form goal.
// Used by both FormGoalSelection (interstitial) and FormGoal (editor step).
export function buildFormGoalPayload(goal, siteSettings) {
  const allTemplates = siteSettings?.available_form_templates || [];
  const matched = allTemplates.find(t => t.form_type === goal.form_type) || allTemplates[0];

  return {
    element_subtype: 'forms',
    subtype: 'forms',
    form_type: goal.form_type,
    form_template_id: matched?.id || null,
    form_template_name: matched?.name || null,
    form_template_theme: matched?.form_template_theme || 'customer-feedback-survey',
    form_questions: matched?.defaults?.questions || [],
  };
}
